import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './PatrollPersonal.css'; // Import your CSS file for styling

export default function PatrollPersonal() {
  const { empid } = useParams();
  const [payroll, setPayroll] = useState([]);

  useEffect(() => {
    fetchPayrollDetails();
  }, []);

  async function fetchPayrollDetails() {
    try {
      const res = await fetch("https://payrole.onrender.com/Alldetailsofemp", {
        method: 'POST',
        body: JSON.stringify({empid}),

        headers: { 'Content-Type': 'application/json' }
      });

      const payrollData = await res.json();
      setPayroll(payrollData);
    } catch (error) {
      console.error("Error fetching payroll details:", error);
    }
  }

  return (
    <div className="card-container">
      <div className="payroll-card">
        <div className="payroll-details">
          <h2>{payroll.FirstName} {payroll.LastName}</h2>
          <p>EMPLOY ID: {empid}</p>
          <p>Salary: {payroll.SalaryAmount}</p>
          <p>DEPT ID: {payroll.DepartmentID}</p>
          <p>Department: {payroll.DepartmentName}</p>
          <p>Payroll ID: {payroll.SalaryID}</p>
          <p>Payroll Date: {payroll.PayrollDate}</p>
          <p>Net Pay: {payroll.NetPay}</p>
        </div>
      </div>
    </div>
  );
}
